/**
 * @generated SignedSource<<9a78687de471c5c3e7a0efd2848ba161>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type AssignmentState = "COMPLETE" | "IN_PROGRESS" | "%future added value";
export type SortEnumType = "ASC" | "DESC" | "%future added value";
export type AssignmentsFilterInput = {
  assignmentState?: AssignmentState | null | undefined;
  classIds?: ReadonlyArray<string> | null | undefined;
  dueOnFrom?: any | null | undefined;
  dueOnTo?: any | null | undefined;
  isActive: ActiveRecords;
  nameContains?: string | null | undefined;
  skillIds?: ReadonlyArray<string> | null | undefined;
  startedOnFrom?: any | null | undefined;
  startedOnTo?: any | null | undefined;
};
export type AssignmentSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  dueOn?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  skill?: SkillSortInput | null | undefined;
  startedOn?: SortEnumType | null | undefined;
};
export type SkillSortInput = {
  assessmentInfo?: SortEnumType | null | undefined;
  code?: SortEnumType | null | undefined;
  context?: SortEnumType | null | undefined;
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  difficulty?: SortEnumType | null | undefined;
  essentialQuestion?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  lessonInfo?: SortEnumType | null | undefined;
  mapCutoffScore?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  name?: SortEnumType | null | undefined;
  progressionNotes?: SortEnumType | null | undefined;
  summary?: SortEnumType | null | undefined;
};
export type UserSortInput = {
  createdBy?: UserSortInput | null | undefined;
  createdOn?: SortEnumType | null | undefined;
  email?: SortEnumType | null | undefined;
  externalSync?: ExternalSyncSortInput | null | undefined;
  externalSyncId?: SortEnumType | null | undefined;
  firstName?: SortEnumType | null | undefined;
  fullName?: SortEnumType | null | undefined;
  id?: SortEnumType | null | undefined;
  isActive?: SortEnumType | null | undefined;
  isMetabaseAccessEnabled?: SortEnumType | null | undefined;
  isMetabaseEmailEnabled?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastName?: SortEnumType | null | undefined;
  lastNameFirst?: SortEnumType | null | undefined;
  modifiedBy?: UserSortInput | null | undefined;
  modifiedOn?: SortEnumType | null | undefined;
  owner?: UserSortInput | null | undefined;
  publicUserId?: SortEnumType | null | undefined;
};
export type ExternalSyncSortInput = {
  id?: SortEnumType | null | undefined;
  isObfuscated?: SortEnumType | null | undefined;
  lastUpdatedOn?: SortEnumType | null | undefined;
  source?: SortEnumType | null | undefined;
};
export type AssignmentGetAssignmentsQuery$variables = {
  after?: string | null | undefined;
  before?: string | null | undefined;
  filter: AssignmentsFilterInput;
  first?: number | null | undefined;
  last?: number | null | undefined;
  order?: ReadonlyArray<AssignmentSortInput> | null | undefined;
  skip?: boolean | null | undefined;
};
export type AssignmentGetAssignmentsQuery$data = {
  readonly assignments?: {
    readonly nodes: ReadonlyArray<{
      readonly classes: ReadonlyArray<{
        readonly id: string;
        readonly name: string | null | undefined;
        readonly owner: {
          readonly lastName: string | null | undefined;
        } | null | undefined;
        readonly section: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly createdBy: {
        readonly firstName: string | null | undefined;
        readonly id: string;
        readonly lastName: string | null | undefined;
      } | null | undefined;
      readonly dueOn: any;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly skill: {
        readonly code: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
      readonly startedOn: any;
      readonly studentSkillAssignments: ReadonlyArray<{
        readonly id: string;
        readonly submittedOn: any | null | undefined;
      } | null | undefined> | null | undefined;
    }> | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
    readonly totalCount: number;
  } | null | undefined;
};
export type AssignmentGetAssignmentsQuery = {
  response: AssignmentGetAssignmentsQuery$data;
  variables: AssignmentGetAssignmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "order"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "skip"
},
v7 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "before",
    "variableName": "before"
  },
  {
    "kind": "Variable",
    "name": "filter",
    "variableName": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "last",
    "variableName": "last"
  },
  {
    "kind": "Variable",
    "name": "order",
    "variableName": "order"
  }
],
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dueOn",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startedOn",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "UserNode",
  "kind": "LinkedField",
  "name": "createdBy",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    (v12/*: any*/),
    (v8/*: any*/)
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "concreteType": "SkillNode",
  "kind": "LinkedField",
  "name": "skill",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    (v9/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "code",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "filter",
      "value": {
        "isActive": "ACTIVE"
      }
    }
  ],
  "concreteType": "StudentSkillAssignmentNode",
  "kind": "LinkedField",
  "name": "studentSkillAssignments",
  "plural": true,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "submittedOn",
      "storageKey": null
    }
  ],
  "storageKey": "studentSkillAssignments(filter:{\"isActive\":\"ACTIVE\"})"
},
v17 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasPreviousPage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startCursor",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentGetAssignmentsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "AssignmentNodeConnection",
            "kind": "LinkedField",
            "name": "assignments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssignmentGetAssignmentsQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v7/*: any*/),
            "concreteType": "AssignmentNodeConnection",
            "kind": "LinkedField",
            "name": "assignments",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "AssignmentNode",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ClassNode",
                    "kind": "LinkedField",
                    "name": "classes",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v15/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "UserNode",
                        "kind": "LinkedField",
                        "name": "owner",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v16/*: any*/)
                ],
                "storageKey": null
              },
              (v17/*: any*/),
              (v18/*: any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "247e442c036fad27a02a3e67d9694630",
    "id": null,
    "metadata": {},
    "name": "AssignmentGetAssignmentsQuery",
    "operationKind": "query",
    "text": "query AssignmentGetAssignmentsQuery(\n  $filter: AssignmentsFilterInput!\n  $first: Int\n  $after: String\n  $last: Int\n  $before: String\n  $order: [AssignmentSortInput!]\n  $skip: Boolean = false\n) {\n  assignments(filter: $filter, first: $first, last: $last, after: $after, before: $before, order: $order) @skip(if: $skip) {\n    nodes {\n      id\n      name\n      dueOn\n      startedOn\n      createdBy {\n        firstName\n        lastName\n        id\n      }\n      skill {\n        id\n        name\n        code\n      }\n      classes {\n        id\n        name\n        section\n        owner {\n          lastName\n          id\n        }\n      }\n      studentSkillAssignments(filter: {isActive: ACTIVE}) {\n        id\n        submittedOn\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n      hasPreviousPage\n      startCursor\n    }\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "4aeb4c50f28ddcd91bb387f994ab57f3";

export default node;
